import React, {Component} from 'react';
import {Modal} from "react-bootstrap";
import {request} from "../helper/APIUtils";
import {showAxiosError} from "../helper/helper";
import {contractRateTypeEnum, serviceTypeEnum} from "../helper/enums";
import moment from 'moment';

class EdefterSecondCopyApplicationModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			customer: null,

		};

		this.doEdefterSecondCopyApplication = this.doEdefterSecondCopyApplication.bind(this);
		this.getCustomer = this.getCustomer.bind(this);
		this.prepareCustomer = this.prepareCustomer.bind(this);
	}

	componentDidMount() {
		this.getCustomer();
	}

	getCustomer() {
		let self = this;
		let params = {
			url: '/customer/findByRecordId/' ,
			method: "post",
			data: self.props.currentUser.customerId,
		};

		if(!self.props.currentUser.customerId){
			return;
		}

		self.setState({ loading: true});
		request(params).then(function (response) {
			let customer = response.data;
			self.setState({ customer, loading: false});
		}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	doEdefterSecondCopyApplication() {
		let self = this;
		let customer = this.prepareCustomer();
		console.log("customer",customer);
		let params = {
			url: '/customer/createCustomer',
			method: "post",
			data: customer
		};

		self.setState({ loading: true });

		request(params).then(function (response) {
			self.setState({ loading: false });
			self.props.refresh();
		}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	render() {
		return (
			<Modal show={this.props.edefterSecondCopyApplicationModal} onHide={this.props.close} size='lg'>
				<Modal.Header closeButton style={{padding: '22px 25px'}}>e-Defter İkincil Kopya Saklama Hizmeti Başvurusu</Modal.Header>
				<Modal.Body>
					<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>

						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '80%'}}>
							<img src='image/defterlogo.png' style={{width:"30%"}} alt="logo"/>
							<p style={{
								fontSize: '16px',
								fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
								fontWeight: '400',
								marginBottom: '0',
								textAlign: 'center',
								lineHeight: '15px'
							}}><b>e-Defter İkincil Kopya Saklama Hizmeti</b> başvurunuzu onayladığınızda
								sözleşme imzalama sayfasına yönlendirileceksiniz.<br/>
								<b>Lütfen e-imzanızı yanınızda bulundurunuz.</b>
							</p>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
						<div>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
										padding: '10px 54px 10px 23px'
									}}
									rel="tooltip" className="TekBtn vazgec btn-icon"
									onClick={this.props.close}>
								İptal
							</button>
						</div>

						<div>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										padding: '10px 54px 10px 23px',
										float:'right'
									}}
									rel="tooltip" className="TekBtn kaydet btn-icon"
									disabled={this.state.loading}
									onClick={() => this.doEdefterSecondCopyApplication()}>Onayla
							</button>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		)
	}

	prepareCustomer() {
		let customer = this.state.customer;

		let customerContractServiceList = [{
			aliasList: [{workScopecode: null}],
			service: {recordId: serviceTypeEnum.E_DEFTER_IKINCIL_KOPYA},
			terminated : false,
		}];

		let customerContract = {
			recordId : null,
			contractStartDate: moment().format('YYYY-MM-DD'),
			contractFinishDate: moment().add(1,'years').format('YYYY-MM-DD'),
			rateType: (customer.customerContractList.length > 0 ? customer.customerContractList[0].rateType : contractRateTypeEnum.INVOICED),
			automaticExtension: false,
			customerContractServiceList: customerContractServiceList,
		};

		customer.customerContractList.push(customerContract);

		return customer;
	}
}

export default EdefterSecondCopyApplicationModal;